var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7726 22.64C11.4192 23.0644 10.7886 23.122 10.3642 22.7686C9.93982 22.4152 9.88225 21.7846 10.2357 21.3602L14.6989 16.0001L10.2351 10.64C9.88171 10.2156 9.93924 9.58505 10.3636 9.23163C10.788 8.8782 11.4186 8.93573 11.772 9.36012L16.7687 15.3601C17.0774 15.7308 17.0774 16.2692 16.7687 16.6399L11.7726 22.64Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7723 22.64C18.4189 23.0644 17.7884 23.122 17.364 22.7686C16.9396 22.4152 16.882 21.7846 17.2354 21.3602L21.6987 16.0001L17.2349 10.64C16.8815 10.2156 16.939 9.58507 17.3634 9.23164C17.7878 8.87821 18.4183 8.93575 18.7718 9.36014L23.7684 15.3601C24.0772 15.7309 24.0772 16.2692 23.7685 16.6399L18.7723 22.64Z",
    fill: "currentColor"
  })));
};
export default SvgRightArrow;